import React, { useEffect } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { WIDTH_100 } from "../../../utils/GlobalConstants";

const DataPicker = (props) => {
  const [value, setValue] = React.useState();

  useEffect(() => {
    setValue(dayjs(props.value));
  }, [props.value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          sx={WIDTH_100}
          slotProps={{ textField: { size: "small" } }}
          label={props.label}
          value={dayjs(value)}
          onChange={(newValue) => setValue(newValue)}
          disabled={props.disabled ? props.disabled : false}
          readOnly={props.readOnly ? true : false}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default DataPicker;
